import { yupResolver } from "@hookform/resolvers/yup";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";
import { Button, Card, Flex, Spinner } from "@radix-ui/themes";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import SelectComponent from "../../../components/inputs/Select/SelectComponent";
import TextFieldComponent from "../../../components/inputs/Textfield/TextfieldComponent";
import { routes } from "../../../routes";
import { createLateFeeConfig } from "../../../services/finance/lateFeeConfig";
import { LateFeeConfigType } from "../../../types/Finance";
import { CreateLateFeeConfigFormValidation } from "./CreateLateFeeConfigFormValidation";
import { useGetPaymentTypesQuery } from "../../../hooks/useGetPaymentTypesQuery";

export const CreateLateFeeConfig = () => {
  const navigate = useNavigate();
  const mutation = useMutation({ mutationFn: createLateFeeConfig, mutationKey: 'createLateFeeConfig' });
  const { data:paymentTypesData} = useGetPaymentTypesQuery({ PageNumber: 1, PageSize: 4000 });
  const defaultValues:LateFeeConfigType={
    feeAmount: 0,
    feePercentage: 0,
    idPaymentType: "",
    startDay: 0,
    endDay: 0,
    daysAfterDueDate: 0
  }
  const { control, handleSubmit, formState: { errors } , setValue , watch} = useForm<LateFeeConfigType>
  (
    {
      defaultValues,
      resolver: yupResolver(CreateLateFeeConfigFormValidation),
      mode: 'onBlur',
      reValidateMode: 'onBlur',
      shouldUseNativeValidation: false,
    }
  );
  const onSubmit = handleSubmit(async (data) => {
    try {
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success("Regra criada com sucesso!");
        navigate(routes.lateFeeConfigs);
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });
  const handleBack = () => {
    navigate(routes.lateFeeConfigs);
  }
  const watchFeePercentage = watch('feePercentage');
  const watchIdPayment = watch('idPaymentType');
  const handleSelectPaymentType = (id:string) => {
    const paymentType = paymentTypesData?.items.find(i=> i.id===id);
    const amount = paymentType?.amount??0;
    const feeAmount = ( amount *  (watchFeePercentage/100));
    setValue('feeAmount', feeAmount)
  }
  const handleFeePercentageChange = (e: any) => {
    const feePercentage =e?.target?.value;
    setValue('feePercentage', Number(feePercentage))
    const paymentType = paymentTypesData?.items.find(i=> i.id===watchIdPayment);
    const amount = paymentType?.amount??0;
    const feeAmount =( amount *  (feePercentage/100));
    setValue('feeAmount', feeAmount)
  }
  return (
    <form onSubmit={onSubmit} noValidate>
      <Card size='1'>
        <Flex direction='column' gap='4'>
        <SelectComponent name="idPaymentType" label="Tipo de emolumento" control={control} errors={errors} style={{ width: '100%' }}
            options={paymentTypesData?.items.map((paymentType) => ({
              value:  paymentType?.id?? "",
              label: paymentType?.description ?? ""
            }))}
            onSelect={handleSelectPaymentType}
            required={true}
          />
          <Flex direction='row' gap='4'>
            <TextFieldComponent name="feePercentage" label="Percentagem de atraso (%)" control={control} errors={errors} fieldProps={{ placeholder: 'Percentagem de atraso', onChange: handleFeePercentageChange }}  style={{ width: '100%' }}/>
            <TextFieldComponent name="startDay" label="Dia inicial" control={control} errors={errors} fieldProps={{ placeholder: 'Dia inicial' }} style={{ width: '100%' }} />
            <TextFieldComponent name="endDay" label="Dia limite" control={control} errors={errors} fieldProps={{ placeholder: 'Dia limite' }} style={{ width: '100%' }} />
            {/* <TextFieldComponent name="daysAfterDueDate" label="Número de dias" control={control} errors={errors} fieldProps={{ placeholder: 'Número de dias' }} style={{ width: '100%' }} /> */}
            <TextFieldComponent name="feeAmount" label="Valor de atraso" control={control} errors={errors} fieldProps={{ placeholder: 'Valor de atraso', disabled: 'disabled' }} style={{ width: '100%' }} />
          </Flex>
          <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
            <Button type="button" variant="soft" color="gray" onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> Voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading}>
              {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
              Registar
            </Button>
          </Flex>
        </Flex>
      </Card>
    </form>
  );
}
